<template>
  <div v-loading="loading" class="salesOrderPreview">
    <div>
      <div style="border-bottom: 1px solid #ddd; margin-bottom: 10px; padding-bottom: 5px; font-size: 16px">基本信息</div>
      <table class="gridtable" style="width: 100%" cellpadding="0" cellspacing="0">
        <tr>
          <td class="tableLabel">客户</td>
          <td>{{delivery.purchaseUnit}}</td>
          <td class="tableLabel">签收状态</td>
          <td>{{delivery.receiptStatus}}</td>
          <td class="tableLabel">签收时间</td>
          <td>{{delivery.signedTime}}</td>
        </tr>
        <tr>
          <td class="tableLabel">信贷状态</td>
          <td>{{delivery.creditStatusName}}</td>
          <td class="tableLabel">过账状态</td>
          <td v-if="delivery.postingStatus === 'A'">未过账</td>
          <td v-if="delivery.postingStatus === 'B'">部分过账</td>
          <td v-if="delivery.postingStatus === 'C'">已过账</td>
          <td class="tableLabel">过账时间</td>
          <td style="width: 23%">{{delivery.postingTime}}</td>
        </tr>
        <tr>
          <td class="tableLabel">发货单号</td>
          <td style="width: 23%">{{delivery.billNo}}</td>
          <td class="tableLabel">制单人</td>
          <td style="width: 23%">{{delivery.creatorName}}</td>
          <td class="tableLabel">制单时间</td>
          <td>{{delivery.createTime}}</td>
        </tr>
        <tr>
          <td class="tableLabel">SAP订单号</td>
          <td>{{delivery.salesOrderNo}}</td>
          <td class="tableLabel">发货单状态</td>
          <td>{{delivery.statusName}}</td>
          <td class="tableLabel">物流状态</td>
          <td>{{delivery.logisticStatusName}}</td>
        </tr>
        <tr>
          <td class="tableLabel">发货地址</td>
          <td>{{delivery.deliveryAddress}}</td>
          <td class="tableLabel">联系人</td>
          <td>{{delivery.contact}}</td>
          <td class="tableLabel">联系方式</td>
          <td>{{delivery.phone}}</td>
        </tr>
        <tr>
          <td class="tableLabel">交货日期</td>
          <td>{{delivery.deliveryDate}}</td>
          <td class="tableLabel">客户合同号</td>
          <td>{{delivery.customerContractNo}}</td>
          <td class="tableLabel">工控合同号</td>
          <td>{{delivery.clientContractNo}}</td>
        </tr>
        <tr>
          <td class="tableLabel">订单类型</td>
          <td>{{delivery.salesOrderCategoryName}}</td>
          <td class="tableLabel">快递单号</td>
          <td>{{delivery.logisticsOrderNo}}</td>
          <td class="tableLabel"></td>
          <td></td>
        </tr>
      </table>
    </div>
    <div>
      <div style="border-bottom: 1px solid #ddd; margin-bottom: 10px; padding-bottom: 5px; font-size: 16px; margin-top: 20px; display: flex; flex-direction: row; align-items: center; justify-content: space-between">
        <div>订单商品</div>
      </div>
      <el-table
          ref="payData"
          :expand-row-keys="expandRowKeys"
          row-key="pkId"
          border
          :data="delivery.detailAppVOS">
        <el-table-column align="center" prop="rowIndex" label="#" width="80"/>
        <el-table-column align="center" prop="materialNo" label="物料编号" width="150"/>
        <el-table-column align="center" prop="mappingMaterialNo" label="旧物料号" width="150"/>
        <el-table-column
            align="center"
            prop="materialName"
            label="物料名称"
            min-width="200"
            show-overflow-tooltip/>
        <el-table-column align="center" prop="specification" label="规格型号" width="150"/>
        <el-table-column align="center" prop="quantity" label="数量" width="60"/>
        <el-table-column align="center" prop="unit" label="单位" width="50"/>
        <el-table-column
            align="center"
            prop="location"
            label="仓库"
            width="100"
            :formatter="(row) => constant.locationNo[row.location]"/>
        <el-table-column align="center" prop="locationNo" label="小仓位" width="100"/>
        <el-table-column align="center" prop="stockNumber" label="库存数量" width="100"/>
        <el-table-column align="center" prop="note" label="备注" show-overflow-tooltip/>
      </el-table>
    </div>
    <div>
      <div style="border-bottom: 1px solid #ddd; margin-bottom: 10px; padding-bottom: 5px; font-size: 16px; margin-top: 20px">
        签收单
      </div>
      <el-table ref="payData1" border :data="delivery.accessoryList">
        <el-table-column type="index" align="center" label="#" width="55"/>
        <el-table-column
            prop="fileName"
            align="left"
            label="附件描述"
            width="750"
            show-overflow-tooltip/>
        <el-table-column label="操作" width="200" fixed="right">
          <template slot-scope="scope">
            <down-load-file :file-key="scope.row.filePath"/>
          </template>
        </el-table-column>
        <el-table-column prop="note" align="center" label="备注" show-overflow-tooltip/>
      </el-table>
    </div>
    <div>
      <div style="border-bottom: 1px solid #ddd; margin-bottom: 10px; padding-bottom: 5px; font-size: 16px; margin-top: 20px">
        商务上传发货单
      </div>
      <el-table ref="payData1" border :data="delivery.customerFileList">
        <el-table-column type="index" align="center" label="#" width="55"/>
        <el-table-column
            prop="fileName"
            align="left"
            label="附件描述"
            width="750"
            show-overflow-tooltip/>
        <el-table-column label="操作" width="200" fixed="right">
          <template slot-scope="scope">
            <down-load-file :file-key="scope.row.filePath"/>
          </template>
        </el-table-column>
        <el-table-column prop="note" align="center" label="备注" show-overflow-tooltip/>
      </el-table>
    </div>
  </div>
</template>
<script>

  import DownLoadFile from "@/components/DownLoadFile";
  import constant from "@/util/constant";

  export default {
    name: "SalesDeliveryBillPreview",
    components: {DownLoadFile},
    data() {
      return {
        constant,
        actionUrl: window.config.basicServerUrl + "file/upload",
        expandRowKeys:[],
        priceAuth: this.$auth(751),
        downloadAuth: this.$auth(755),
        loading: false,
        billType:"",
        billId:"",
        downLoadLoading: false,
        flag: true,
        files:[],
        fileList:[],
        totalAmount: 0,
        deliveryPlace: "",  // 收货地址
        delivery: {
          detailList:[],
        },
      };
    },
    watch:{
      $route:{
        handler:function(val) {
          console.log(val);
          if(val.name === "SalesDeliveryBillPreview") {
            this.getData(this.$route.query.billId,this.$route.query.billType);
          }
        },
      },
    },

    created() {
      this.getData(this.$route.query.billId,this.$route.query.billType);
    },
    methods: {
      // 根据销售订单id查询详细信息
      getData(id) {
        this.loading = true;
        this.billId = id;
        this.$http.get("basic", `sapDeliveryBills/getById/${id}`).then((resp) => {
          console.log("订单数据：",resp);
          if(resp.success) {
            this.delivery = resp.data;
            for (let item of this.delivery.detailAppVOS) {
              this.totalAmount += item.quantity * item.price;
            }
            this.loading = false;
            if(this.delivery.accessoryList.length === 0) {
              this.flag = false;
            }
            this.$refs.payData.sort("rowIndex","ascending");
          }
        });
      },
      downloadAll() {
        if(this.delivery.accessoryList.length === 0) {
          this.$message.error("没有可下载的附件！");
        }
        for(let item of this.delivery.accessoryList) {
          this.download(item);
        }
      },
      //下载单个附件
      download(row) {
        let data = {
          name:row.fileName,
          uuid:row.filePath,
        };
        this.$http.exportFile("basic","files/download",data).then(res => {
          console.log(res);
          let blob = new Blob([res.data],{type:"application/pdf"});
          let fileName = decodeURI(res.config.params.name);
          if (window.navigator && window.navigator.msSaveOrOpenBlob) {
            navigator.msSaveBlob(blob, fileName);
          } else {
            let a = document.createElement("a");
            a.href = URL.createObjectURL(blob);
            a.download = fileName;
            a.style.display = "none";
            document.body.appendChild(a);
            a.click();
            URL.revokeObjectURL(a.href);
            document.body.removeChild(a);
          }
          this.downLoadLoading = false;
        }).catch(() => {
          this.downLoadLoading = false;
          this.$message.error("下载失败");
        });
      },

      // 上传失败
      handlerError(err) {
        this.$confirm(err, "错误", {
          type: "error",
          showCancelButton: false,
        });
      },

      // 上传成功
      handleSuccess(response, file, fileList) {
        file.path = response;
        this.files = fileList;
        let object = {
          fileName: file.path.originalName,
          filePath: file.path.fullPath,
        };
        this.delivery.accessoryList.push(object);
        this.$http.post("basic", "sapSalesOrders/upLoadFile", this.delivery).then(()=>{
          this.$message.success("上传成功");
        }).catch(()=>{
          this.$message.error("上传失败");
        });
      },

      // 点击上传时的移除
      handleRemove(fileList) {
        this.files = fileList;
      },
    },
  };
</script>
<style lang="scss">
  @media (max-width: 1280px) {
    .salesOrderPreview {
      width: 97%;
      overflow-x: scroll;
    }
  }
  .salesOrderPreview {
    .el-table th {
      background: #d1e6f5;
      height: 34px;
    }
    table.gridtable {
      font-family: verdana, arial, sans-serif;
      font-size: 11px;
      color: #333333;
      border: 1px solid #dddddd;
      border-bottom: none;
    }
    table.gridtable th {
      text-align: left;
      padding: 8px;
      background-color: #d1e6f5;
    }
    table.gridtable td {
      border-width: 1px;
      padding: 8px;
      border-style: solid;
      border-color: #dddddd;
      border-top: none;
      border-right: none;
    }
    .tableLabel {
      width: 80px;
      text-align: right;
      background-color: #d1e6f5;
    }
    .el-button {
      margin-left: 0 !important;
      margin-right: 5px !important;
    }
  }
</style>
